import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDispatch } from "react-redux";
import { Input, Label } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  getAllServices,
  updateService,
} from "../../../../store/slices/servicesSlice";
import { getAllPrograms } from "../../../../store/slices/programsSlice";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  createSubService,
  getAllSubServices,
} from "../../../../store/slices/subServicesSlice";
import SweetAlert from "sweetalert2";
import CreatetableSelect from "react-select/creatable";
import debounce from "lodash.debounce";
import UploadComponent from "../../Components/uploadComponent";
import MbForm from "./mbform";
import { unwrapResult } from "@reduxjs/toolkit";

const SubServiceForm = forwardRef((props, ref) => {
  const { formType, toggle, pagination } = props;
  const dispatch = useDispatch();
  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const [formFields, setFormFields] = useState({
    name: "",
    description: "",
    service_id: "",
    // mb_form: {},
    type:"grouped"
  });
  console.log(formFields, "create sub service");
  const [isEdit, setIsEdit] = useState(false);
  const {
    register,
    trigger,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues: { name: "", description: "", service_id: "",type:"grouped" } });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    program_id: {
      ...register("program_id", { required: "This field is required" }),
    },
    name: {
      ...register("name", { required: "This field is required" }),
    },
    description: {
      ...register("description", { required: "This field is required" }),
    },
    service_id: {
      ...register("service_id", { required: "This field is required" }),
    },
    type: {
      ...register("type", { required: "This field is required" }),
    },
  });

  const allPrograms = useSelector(
    (state) => state.programs.allProgramsData
  ).map((program) => ({
    label: program.name,
    value: program.ID,
  }));
  const allServices = useSelector((state) => state.services.allServices);
  const serviceDetails = useSelector((state) => state.services.serviceDetail);
  const allSubServices = useSelector(
    (state) => state.subServices.allSubServices
  ).map((subService) => ({ label: subService?.name, value: subService.ID }));
  const subServiceDetail = useSelector(
    (state) => state.subServices.subServiceDetail
  );
  const [file, setFile] = useState(null);
  const [typeOfBenefit, setTypeOfBenfefit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);

  useEffect(() => {
    fetchAllServices();
    fetchAllSubServices();
    // Only set the default service_id if formFields.service_id is empty (initial load)
    if (!formFields.service_id && serviceDetails?.ID) {
      setValue("service_id", serviceDetails.ID);
      setFormFields({ ...formFields, service_id: serviceDetails.ID });
    }
  }, [serviceDetails?.ID]);

  const fetchAllServices = () => {
    dispatch(getAllServices());
  };

  const fetchAllSubServices = () => {
    dispatch(getAllSubServices());
  };

  useEffect(() => {
    fetchAllPrograms();
    if (formType === "edit") {
      init();
    }
  }, []);

  useImperativeHandle(ref, () => ({
    async handleSubmit() {
      let isValid = await trigger();
      console.log(errors);
      if (isValid) {
        if (formType === "edit" || isEdit) {
          dispatch(
            updateService({
              ...formFields,
              program_id: formFields?.program_id?.value,
              pagination: pagination,
            })
          );
        } else {
          let result = await popUp();
          if (result) {
            try {
              let payload = formFields;
              console.log("payload",payload)
              if (formFields?.name?.__isNew__) {
                payload = {
                  ...payload,
                  isNew: true,
                  name: payload?.name.label,
                  program_id: formFields?.program_id,
                };
                if (client === "ts") {
                  payload["program_name"] =
                    serviceDetails.name.split("_default")[0];
                }
              } else {
                payload = {
                  ...payload,
                  service_id: payload.service_id,
                  subService_id: formFields?.name?.value,
                  program_id: formFields?.program_id,
                };
                
                if (client === "ts") {
                  payload = {
                    subService_id: formFields?.name?.value,
                    program_name: serviceDetails.name.split("_default")[0],
                  };
                }
              }

              if (file) {
                let formData = new FormData();
                formData.append("file", file);
                Object.keys(payload).forEach((key) => {
                  formData.append(key, payload[key]);
                });
                console.log("formData", formData)
                dispatch(createSubService(formData));
                unwrapResult(formData);
                return true;
              } else {
                console.log("Final payload before dispatch:", JSON.stringify(payload, null, 2));

                let data = await dispatch(createSubService({ ...payload }));
                unwrapResult(data);
                console.log(data, "create");
                return true;
              }
            } catch (err) {
              console.log(err);
              SweetAlert.fire({
                title: "Error",
                text: `Duplicate Entry For ${formFields.name.label}`,
                icon: "error",
                confirmButtonText: "OK",
              });
              return false;
            }
          }
        }
      } else {
        console.log("invalid");
        return false;
      }
    },
  }));

  const handleInput = (event, field) => {
  console.log("handleInput called with:", event, field);

  let value;
  let setValueArg;

  if (field === "name") {
    // Always store the raw value (ID or string)
    value = event;
    setValueArg =  event?.value || event?.label || event;
    console.log("valName", value);
  } else if (field === "description") {
    value = event;
    setValueArg = event;
    console.log("valdesc", value);
  } else if (field === "program_id") {
    value = event ? event.value : "";
    setValueArg = event ? event.value : "";
    console.log("valProg", value);
  } else if (field === "type") {
    value = event.value;
    setValueArg = event.value;
    setValue("type", setValueArg);
    setFormFields({ ...formFields, type: value });
    return;
  } else {
    value = event.target.value;
    setValueArg = event.target.value;
  }

  console.log("Setting field:", field, "to value:", setValueArg);
  setValue(field, setValueArg, { shouldValidate: true });
  setFormFields((prev) => {
    const updated = { ...prev, [field]: value };
    console.log("Updated formFields:", updated);
    return updated;
  });
};


  const init = () => {};

  const fetchAllPrograms = () => {
    dispatch(getAllPrograms());
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  const popUp = () => {
    // Find the selected service name from allServices based on the selected service_id
    const selectedService = allServices.find(service => service.ID == formFields.service_id);
    const serviceName = selectedService ? selectedService.name : 'the selected service';
    
    return SweetAlert.fire({
      title: "Are you sure?",
      text: `You want to create sub service under ${serviceName}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        return true;
      } else {
        return false;
      }
    });
  };

  const debouncedSearch = useCallback(
    debounce(async (searchTerm) => {
      if (!searchTerm) return;

      try {
        console.log(searchTerm);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }, 500),
    [] // The empty array ensures the debounce function is created only once
  );

  const searchSubServices = (value) => {
    console.log(value);
  };
  
  return (
    <div className="px-2">
      <div>
        <Label>Select Plan<span className="text-danger">*</span></Label>
        <CreatetableSelect
          options={allPrograms}
          value={allPrograms.find((p) => p.value === formFields.program_id) || null}
          onChange={(selectedOption) => handleInput(selectedOption, "program_id")}
          isClearable
          required
        />

        {errors?.program_id && (
          <span className="mt-1 text-danger">{errors.program_id.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Sub Service Name<span className="text-danger">*</span></Label>
       <CreatetableSelect
        options={allSubServices}
        value={formFields.name}
        onChange={(selectedOption) => handleInput(selectedOption, "name")}
        isClearable
        required
      />
        {errors?.name && (
          <span className="mt-1 text-danger">{errors.name.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Sub Service Description<span className="text-danger">*</span></Label>
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={formFields?.description}
          {...formFieldsValidation.description}
          onChange={(event) => handleInput(event, "description")}
        />
        {errors?.description && (
          <span className="mt-1 text-danger">
            {errors?.description?.message}
          </span>
        )}
      </div>
      <div className="mt-4">
        <Label>Select Service</Label>
        <Input
          type="select"
          name="select"
          className="form-control digits"
          value={formFields.service_id || ""}
          {...formFieldsValidation.service_id}
          onChange={(event) => handleInput(event, "service_id")}
        >
          <option value="">Select a service...</option>
          {allServices.map((service, index) => (
            <option key={index} value={service.ID}>
              {service?.name}
            </option>
          ))}
        </Input>
        {errors?.service_id && (
          <span className="mt-1 text-danger">
            {errors?.service_id?.message}
          </span>
        )}
      </div>
      <div className="mt-4">
  <Label>Select Benefit Type</Label>
      <CreatetableSelect
        options={typeOfBenefit}
        onChange={(event) => handleInput(event, "type")}
        value={typeOfBenefit.find((x) => x.value === formFields.type)}
      />
      {errors.type && (
        <span className="mt-1 text-danger">{errors.type.message}</span>
      )}
    </div>

      <div className="mt-4">
        <UploadComponent addFile={setFile}></UploadComponent>
      </div>
    </div>
  );
});

export default SubServiceForm;
